/* ═══════════════════════════════════════════════════════════════════
   TIFFANYA — GUIDE DES TAILLES — v8.1 — script
   Asset du thème : Assets > Ajouter un fichier > tiffanya-size-guide.js
   Chargé en defer par le bloc Custom Liquid, qui fournit window.TF_FIT
   (pays, système de tailles, grille produit) avant l'exécution.

   v8.1 (sept. 2026)
     • Ouverture SYNCHRONE de la modale (plus de double
       requestAnimationFrame) : un onglet en arrière-plan ou un long task
       ne peut plus laisser l'overlay affiché mais invisible.
     • Calculateur : sous la gamme du style (bust / taille / hanches), le
       message renvoie vers les collections standard (XS–XL) au lieu de
       pousser la plus petite taille curvy. URLs configurables via
       window.TF_FIT.smallerSizesUrl / smallerSizesUrl2.
     • Le bloc v6 (liquid_X8wh8e) doit être ABSENT du template : il
       rendait un second #tf-sg-overlay et câblait les mêmes boutons.
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // Le bloc peut être présent plusieurs fois sur une page : on n'installe
  // le guide qu'une seule fois.
  if (window.__TF_SG_LOADED) return;
  window.__TF_SG_LOADED = true;

  if (!window.TF_FIT) {
    console.warn('[TF Fit] window.TF_FIT absent — le bloc Custom Liquid ' +
                 'n\'a pas été posé, ou il est chargé après ce script.');
    return;
  }

  /* ─── Cohabitation avec une modale de tailles existante ───────────
     Ce thème contient déjà des guides de tailles (ancienne modale
     noire, modale bordeaux du quickview...) qui utilisent tous la
     classe générique .tf-sc-trigger-btn. Si l'un d'eux est présent,
     ce script n'ouvre PAS sa propre modale : il se contente des notes
     "Fits:" sous les sélecteurs et expose l'API. Sinon on aurait deux
     popups superposées au même clic.

     Forçage manuel, à placer AVANT le chargement de ce script :
       window.TF_SG_FORCE = true;    // toujours ouvrir CETTE modale
       window.TF_SG_FORCE = 'off';   // ne jamais l'ouvrir             */
  var FOREIGN_SELECTORS = [
    '#tf-sc-modal-template',   // ancienne modale bordeaux (bloc v16head)
    '.tf2-overlay',            // idem, une fois ouverte
    '.tf-sc-overlay',          // ancienne modale noire (bloc d8KEdj)
    '.js-tf-sc-open'           // son bouton
  ].join(',');
  // Volontairement absent : .tf-qv-root / .js-tf-qv-sc-open. Le
  // quickview ne rend que dans les tiroirs des pages collection, où ce
  // script n'est pas chargé — et le listener ci-dessous est de toute
  // façon limité à .tf-sg-open, donc aucun risque de double ouverture.

  window.TF_FIT.foreignModal = function () {
    if (window.TF_SG_FORCE === true)  return false;
    if (window.TF_SG_FORCE === 'off') return true;
    return !!document.querySelector(FOREIGN_SELECTORS);
  };

  /* ─── Injection du balisage de la modale ─────────────────────────── */
  var MARKUP = "<div id=\"tf-trigger-container\" style=\"display:none;\">\n  <button type=\"button\" class=\"tf-sc-trigger-btn tf-sg-open\">\n    <svg class=\"tf-sc-icon\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.4 2.4 0 0 1 0-3.4l2.6-2.6a2.4 2.4 0 0 1 3.4 0Z\"/><path d=\"m14.5 12.5 2-2\"/><path d=\"m11.5 9.5 2-2\"/><path d=\"m8.5 6.5 2-2\"/><path d=\"m17.5 15.5 2-2\"/></svg>\n    What's my size?\n  </button>\n</div>\n<div class=\"tf-sg tf-sg-overlay\" id=\"tf-sg-overlay\" role=\"dialog\" aria-modal=\"true\"\n     aria-labelledby=\"tf-sg-title\" data-open=\"false\">\n  <div class=\"tf-sg-modal\">\n    <div class=\"tf-sg-head\">\n      <h2 class=\"tf-sg-title\" id=\"tf-sg-title\"></h2>\n      <p class=\"tf-sg-sub\">Size guide</p>\n      <button type=\"button\" class=\"tf-sg-close\" id=\"tf-sg-close\" aria-label=\"Close\">&times;</button>\n    </div>\n    <div class=\"tf-sg-body\">\n      <div class=\"tf-sg-tabs\" role=\"tablist\">\n        <button type=\"button\" class=\"tf-sg-tab\" id=\"tf-tab-chart\" role=\"tab\" aria-selected=\"true\">Size chart</button>\n        <button type=\"button\" class=\"tf-sg-tab\" id=\"tf-tab-calc\"  role=\"tab\" aria-selected=\"false\">Calculate my size</button>\n      </div>\n      <div class=\"tf-sg-regions\" id=\"tf-sg-regions\"></div>\n      <p class=\"tf-sg-region-note\" id=\"tf-sg-region-note\"></p>\n      <!-- ─────────── ONGLET TABLEAU ─────────── -->\n      <section id=\"tf-panel-chart\">\n        <p class=\"tf-sg-intro\">\n          Cut for curves from the first stitch — <strong>high-stretch panels</strong> and forgiving lace.<br>\n          Between two sizes? <strong>Size up.</strong>\n        </p>\n        <h3 class=\"tf-sg-h\" id=\"tf-sg-chart-heading\">Sizes</h3>\n        <div class=\"tf-sg-tablewrap\"><table class=\"tf-sg-table\" id=\"tf-sg-table\"></table></div>\n        <div class=\"tf-sg-callout\">\n          <strong>How to measure.</strong> Use a soft tape, over unpadded underwear, and keep it level.\n          Bust: fullest part of your chest. Waist: narrowest part of your torso. Hips: widest part around\n          your bottom. If two measurements point to different sizes, <strong>follow the larger one</strong>. <strong>Cups</strong> shows which cup sizes the piece is built for at that bust measurement \u2014 read the two together.\n        </div>\n        <div class=\"tf-sg-plain\" id=\"tf-sg-twobox\" hidden>\n          <span class=\"tf-sg-badge\">2 sizes</span><strong>This product uses two sizes</strong>\n          <p style=\"margin:8px 0 0\">Choose the <strong>top</strong> by your bust and the <strong>bottom</strong>\n          by your waist and hips — and mix them freely: that's exactly what this system is made for.</p>\n        </div>\n        <p class=\"tf-sg-fine\" id=\"tf-sg-fine\"></p>\n        <div class=\"tf-sg-trust\">\n          <div><b>4.7/5</b><span>rated on Trustpilot</span></div>\n          <div><b>Free</b><span>size exchanges</span></div>\n          <div><b>30 days</b><span>hassle-free returns</span></div>\n        </div>\n      </section>\n      <!-- ─────────── ONGLET CALCULATEUR ─────────── -->\n      <section id=\"tf-panel-calc\" hidden>\n        <p class=\"tf-sg-intro\">Enter your measurements — your size updates as you go.</p>\n        <div class=\"tf-sg-unit\" role=\"group\" aria-label=\"Measurement unit\">\n          <button type=\"button\" id=\"tf-unit-cm\" aria-pressed=\"true\">CM</button>\n          <button type=\"button\" id=\"tf-unit-in\" aria-pressed=\"false\">IN</button>\n        </div>\n        <div id=\"tf-sg-fields\"></div>\n        <div class=\"tf-sg-result\" id=\"tf-sg-result\"></div>\n      </section>\n      <div class=\"tf-sg-cue\" id=\"tf-sg-cue\"><span>Scroll for more</span><i></i></div>\n\n    </div>\n  </div>\n</div>";

  function inject() {
    if (document.getElementById('tf-sg-overlay')) return false;
    var host = document.createElement('div');
    host.setAttribute('data-morph-skip', '');
    host.innerHTML = MARKUP;
    while (host.firstChild) document.body.appendChild(host.firstChild);
    var title = document.getElementById('tf-sg-title');
    if (title && window.TF_FIT.productName) title.textContent = window.TF_FIT.productName;
    return true;
  }

  function mount() {
    if (document.getElementById('tf-sg-overlay')) return;
    if (window.TF_FIT.foreignModal()) {
      window.TF_FIT.modalDisabled = true;
      return;   // une autre modale gère déjà le guide des tailles
    }
    inject();
  }

  /* TIFFANYA — PONT QUICKVIEW
     Le quickview « View & Save » peut s'ouvrir sur une page dont la
     fiche produit utilise l'ANCIENNE modale (.tf2-overlay du template
     cro-lingerie-set / cro-bodysuit) : foreignModal() est alors vrai et
     mount() s'abstient, à juste titre — on ne veut pas deux popups sur
     la fiche. Mais le produit du quickview, lui, peut avoir besoin de
     CETTE modale-ci. mountForce() la monte à la demande, sans jamais
     toucher au bouton ni aux notes de la page parente.
     Idempotent : appelable autant de fois qu'on veut. */
  window.TF_FIT.mountForce = function () {
    window.TF_FIT.modalDisabled = false;
    if (inject()) {
      try {
        document.dispatchEvent(new CustomEvent('tf:sg:mounted'));
      } catch (e) {}
    }
    return true;
  };

  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount);

})();

/* ═══════════════════════════════════════════════════════════════════
   1. DONNÉES · NOTES "Fits:" · API PUBLIQUE
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════════
     CONFIGURATION
     ═══════════════════════════════════════════════════════════════ */
  var CFG = {
    /* Champs affichés. line1 = principale, line2 = petite et grise.
       Deux dispositions : 'sizeFirst' pour les marchés où la taille de
       robe est fiable, 'measureFirst' pour l'Europe où la conversion
       varie d'un pays à l'autre et où le cm est le seul repère sûr. */
    layouts: {
      /* Une seule ligne courte sous les boutons de taille. Les mesures
         corporelles vivent dans la modale, à un tap de distance : les
         répéter ici alourdissait la fiche produit sans rien apporter.
         Pour les réafficher, remettre 'bust' / 'waist' / 'hips' dans line2. */
      sizeFirst: {
        line1: { bra:['dress','cup'], bottom:['dress'], single:['dress','cup'] },
        line2: { bra:[],              bottom:[],        single:[] }
      },
      measureFirst: {
        line1: { bra:['dress','cup'], bottom:['dress'], single:['dress','cup'] },
        line2: { bra:[],              bottom:[],        single:[] }
      }
    },
    measureFirstSystems: [],   // même mise en forme sur tous les marchés

    // Les deux unités, dans l'ordre de l'habitude locale.
    showBothUnits: false,

    // Le poids ne distingue pas le haut du bas : masqué dès qu'il y a
    // deux sélecteurs de taille.
    hideWeightOnSplitProducts: true,
    weightOnCharts: ['bodysuit', 'lingerie-set', 'bodystocking'],

    // Retiré des notes inline à votre demande. Mettre à true pour le
    // réafficher (il apparaîtrait sous le dernier sélecteur).
    showTieBreak: false,

    /* Découpe les lignes groupées quand la fiche propose les deux
       tailles du groupe. Mettre à false pour réafficher la fourchette
       complète sur les deux (et donc les doublons). */
    splitGroupedRows: true,

    // Révèle explicitement le groupage ("même coupe que S").
    showPairHint: false,

    debug: false
  };

  /* ═══════════════════════════════════════════════════════════════
     SYSTÈMES DE TAILLES
     unit / weight = habitude de mesure locale, pas la norme officielle.
     ═══════════════════════════════════════════════════════════════ */
  var SYSTEMS = {
    US: { key:'US', tab:'US / CA',  label:'US',  unit:'in', weight:'lbs',
          countries:'United States · Canada' },
    UK: { key:'UK', tab:'UK',       label:'UK',  unit:'in', weight:'st',
          countries:'United Kingdom · Ireland' },
    AU: { key:'AU', tab:'AU / NZ',  label:'AU',  unit:'cm', weight:'kg',
          countries:'Australia · New Zealand' },
    EU: { key:'EU', tab:'EUR',      label:'EU',  unit:'cm', weight:'kg',
          countries:'Europe' }
  };
  /* Les quatre viennent des colonnes du fournisseur : US/CA, UK/AU
     (mêmes nombres, unités différentes) et EUR. Plus aucune donnée
     dérivée — les colonnes DE et IT, que je calculais depuis EUR, ont
     été retirées. */

  var T = {
    en: { fits:'Fits: ', bust:' bust', waist:' waist', hips:' hips', cup:'Cups ',
          tieBreak:'Between two sizes? Size up.', pairHint:' — same cut as {other}' },
    fr: { fits:'Correspond à : ', bust:' de poitrine', waist:' de taille', hips:' de hanches',
          cup:'Bonnets ', tieBreak:'Entre deux tailles ? Prenez au-dessus.',
          pairHint:' — même coupe que {other}' }
  };

  /* ═══════════════════════════════════════════════════════════════
     DONNÉES FOURNISSEUR

     dress.US / dress.UK / dress.AU / dress.FR  → colonnes fournisseur
     dress.DE / dress.IT                        → DÉRIVÉES (FR−2 / FR+4)

     Rien d'autre n'est dérivé. Quand le fournisseur ne donne pas une
     donnée (poids sur les corsets, taille de robe sur les
     bodystockings), la valeur reste null et le champ ne s'affiche pas.
     ═══════════════════════════════════════════════════════════════ */

  /* ── Grille A — GROUPÉE (images 2 + 4) : Bodysuit / Lingerie Set ── */
  var ROWS_GROUPED = [
    { group:'Free Size', oneSize:true,
      sizes:['FREE SIZE','ONE SIZE','OS','FREE','TU','TAILLE UNIQUE','UNIQUE'],
      bust:{cm:'81–96',  in:'32–38'}, waist:{cm:'61–76',  in:'24–30'}, hips:{cm:'86–101', in:'34–40'},
      weight:{kg:'45–65',  lbs:'100–140'}, cup:'A/C',
      dress:{US:'4–8',   UK:'8–12',  AU:'8–12',  EU:'36–40'} },

    { group:'XS-S', sizes:['XS','S','XS-S','XS/S'],
      bust:{cm:'81–91',  in:'32–36'}, waist:{cm:'61–71',  in:'24–28'}, hips:{cm:'86–96',  in:'34–38'},
      weight:{kg:'50–65',  lbs:'110–140'}, cup:'A/C',
      dress:{US:'4–6',   UK:'8–10',  AU:'8–10',  EU:'36–38'} },

    { group:'M-L', sizes:['M','L','M-L','M/L'],
      bust:{cm:'91–101', in:'36–40'}, waist:{cm:'71–81',  in:'28–32'}, hips:{cm:'96–106', in:'38–42'},
      weight:{kg:'65–80',  lbs:'140–175'}, cup:'B/C',
      dress:{US:'8–10',  UK:'12–14', AU:'12–14', EU:'40–42'} },

    { group:'XL-2XL', sizes:['XL','2XL','XL-2XL','XL/2XL'],
      bust:{cm:'101–111',in:'40–44'}, waist:{cm:'81–91',  in:'32–36'}, hips:{cm:'106–116',in:'42–46'},
      weight:{kg:'80–95',  lbs:'175–210'}, cup:'C/D',
      dress:{US:'12–14', UK:'16–18', AU:'16–18', EU:'44–46'} },

    { group:'3XL-4XL', sizes:['3XL','4XL','3XL-4XL','3XL/4XL'],
      bust:{cm:'111–122',in:'44–48'}, waist:{cm:'91–101', in:'36–40'}, hips:{cm:'116–127',in:'46–50'},
      weight:{kg:'95–110', lbs:'210–240'}, cup:'C/E',
      dress:{US:'16–18', UK:'20–22', AU:'20–22', EU:'48–50'} },

    { group:'5XL-6XL', sizes:['5XL','6XL','5XL-6XL','5XL/6XL'],
      bust:{cm:'122–132',in:'48–52'}, waist:{cm:'101–111',in:'40–44'}, hips:{cm:'127–137',in:'50–54'},
      weight:{kg:'110–125',lbs:'240–275'}, cup:'D/E',
      dress:{US:'20–22', UK:'24–26', AU:'24–26', EU:'52–54'} }
  ];

  /* ── Grille B — BODYSTOCKING (image 1) : groupage XS-M / L-2XL / 3XL-5XL.
        Le fournisseur ne donne ni bonnet ni taille de robe. ── */
  var ROWS_BODYSTOCKING = [
    { group:'XS-M', sizes:['XS','S','M','XS-M','XS/M'],
      bust:{cm:'81–97',  in:'32–38'}, waist:{cm:'61–76', in:'24–30'}, hips:{cm:'86–102', in:'34–40'},
      weight:{kg:'40–60', lbs:'90–130'}, cup:null, dress:null },

    { group:'L-2XL', sizes:['L','XL','2XL','L-2XL','L/2XL'],
      bust:{cm:'97–112', in:'38–44'}, waist:{cm:'76–91', in:'30–36'}, hips:{cm:'102–117',in:'40–46'},
      weight:{kg:'60–90', lbs:'130–200'}, cup:null, dress:null },

    { group:'3XL-5XL', sizes:['3XL','4XL','5XL','3XL-5XL','3XL/5XL'],
      bust:{cm:'112–127',in:'44–50'}, waist:{cm:'91–107',in:'36–42'}, hips:{cm:'117–132',in:'46–52'},
      weight:{kg:'90–120',lbs:'200–265'}, cup:null, dress:null }
  ];

  /* ── Grille C — BABYDOLL / CHEMISE (image 3) : tailles INDIVIDUELLES ── */
  var ROWS_BABYDOLL = [
    { group:'XS',  sizes:['XS'],  bust:{cm:'81–86',  in:'32–34'}, waist:{cm:'61–66',  in:'24–26'}, hips:{cm:'86–91',  in:'34–36'}, weight:{kg:'40–50', lbs:'90–110'},  cup:null, dress:{US:'4', UK:'8', AU:'8', EU:'36'} },
    { group:'S',   sizes:['S'],   bust:{cm:'86–91',  in:'34–36'}, waist:{cm:'66–71',  in:'26–28'}, hips:{cm:'91–97',  in:'36–38'}, weight:{kg:'45–55', lbs:'100–120'}, cup:null, dress:{US:'6', UK:'10',AU:'10',EU:'38'} },
    { group:'M',   sizes:['M'],   bust:{cm:'91–97',  in:'36–38'}, waist:{cm:'71–76',  in:'28–30'}, hips:{cm:'97–102', in:'38–40'}, weight:{kg:'50–60', lbs:'110–130'}, cup:null, dress:{US:'8', UK:'12',AU:'12',EU:'40'} },
    { group:'L',   sizes:['L'],   bust:{cm:'97–102', in:'38–40'}, waist:{cm:'76–81',  in:'30–32'}, hips:{cm:'102–107',in:'40–42'}, weight:{kg:'60–70', lbs:'130–155'}, cup:null, dress:{US:'10',UK:'14',AU:'14',EU:'42'} },
    { group:'XL',  sizes:['XL'],  bust:{cm:'102–107',in:'40–42'}, waist:{cm:'81–86',  in:'32–34'}, hips:{cm:'107–112',in:'42–44'}, weight:{kg:'70–80', lbs:'155–175'}, cup:null, dress:{US:'12',UK:'16',AU:'16',EU:'44'} },
    { group:'2XL', sizes:['2XL'], bust:{cm:'107–112',in:'42–44'}, waist:{cm:'86–91',  in:'34–36'}, hips:{cm:'112–117',in:'44–46'}, weight:{kg:'80–90', lbs:'175–200'}, cup:null, dress:{US:'14',UK:'18',AU:'18',EU:'46'} },
    { group:'3XL', sizes:['3XL'], bust:{cm:'112–117',in:'44–46'}, waist:{cm:'91–97',  in:'36–38'}, hips:{cm:'117–123',in:'46–48'}, weight:{kg:'90–100',lbs:'200–220'}, cup:null, dress:{US:'16',UK:'20',AU:'20',EU:'48'} },
    { group:'4XL', sizes:['4XL'], bust:{cm:'117–122',in:'46–48'}, waist:{cm:'97–102', in:'38–40'}, hips:{cm:'123–127',in:'48–50'}, weight:{kg:'100–110',lbs:'220–240'},cup:null, dress:{US:'18',UK:'22',AU:'22',EU:'50'} },
    { group:'5XL', sizes:['5XL'], bust:{cm:'122–127',in:'48–50'}, waist:{cm:'102–107',in:'40–42'}, hips:{cm:'127–132',in:'50–52'}, weight:{kg:'110–120',lbs:'240–265'},cup:null, dress:{US:'20',UK:'24',AU:'24',EU:'52'} },
    { group:'6XL', sizes:['6XL'], bust:{cm:'127–132',in:'50–52'}, waist:{cm:'107–112',in:'42–44'}, hips:{cm:'132–137',in:'52–54'}, weight:{kg:'120–130',lbs:'265–285'},cup:null, dress:{US:'22',UK:'26',AU:'26',EU:'54'} }
  ];

  /* ── Grille D — CORSET / BUSTIER (image 5) : tailles INDIVIDUELLES.
        Le fournisseur ne donne pas de poids : ne rien inventer.
        Le corset ne s'étire pas — la mesure de TAILLE prime. ── */
  var ROWS_CORSET = [
    { group:'XS',  sizes:['XS'],  bust:{cm:'81–86',  in:'32–34'}, waist:{cm:'61–66',  in:'24–26'}, hips:{cm:'86–91',  in:'34–36'}, weight:null, cup:null, dress:{US:'4', UK:'8', AU:'8', EU:'36'} },
    { group:'S',   sizes:['S'],   bust:{cm:'86–91',  in:'34–36'}, waist:{cm:'66–71',  in:'26–28'}, hips:{cm:'91–96',  in:'36–38'}, weight:null, cup:null, dress:{US:'6', UK:'10',AU:'10',EU:'38'} },
    { group:'M',   sizes:['M'],   bust:{cm:'91–97',  in:'36–38'}, waist:{cm:'71–76',  in:'28–30'}, hips:{cm:'96–101', in:'38–40'}, weight:null, cup:null, dress:{US:'8', UK:'12',AU:'12',EU:'40'} },
    { group:'L',   sizes:['L'],   bust:{cm:'97–102', in:'38–40'}, waist:{cm:'76–81',  in:'30–32'}, hips:{cm:'101–106',in:'40–42'}, weight:null, cup:null, dress:{US:'10',UK:'14',AU:'14',EU:'42'} },
    { group:'XL',  sizes:['XL'],  bust:{cm:'102–107',in:'40–42'}, waist:{cm:'81–86',  in:'32–34'}, hips:{cm:'106–111',in:'42–44'}, weight:null, cup:null, dress:{US:'12',UK:'16',AU:'16',EU:'44'} },
    { group:'2XL', sizes:['2XL'], bust:{cm:'107–112',in:'42–44'}, waist:{cm:'86–91',  in:'34–36'}, hips:{cm:'111–116',in:'44–46'}, weight:null, cup:null, dress:{US:'14',UK:'18',AU:'18',EU:'46'} },
    { group:'3XL', sizes:['3XL'], bust:{cm:'112–117',in:'44–46'}, waist:{cm:'91–96',  in:'36–38'}, hips:{cm:'116–121',in:'46–48'}, weight:null, cup:null, dress:{US:'16',UK:'20',AU:'20',EU:'48'} },
    { group:'4XL', sizes:['4XL'], bust:{cm:'117–122',in:'46–48'}, waist:{cm:'96–101', in:'38–40'}, hips:{cm:'121–126',in:'48–50'}, weight:null, cup:null, dress:{US:'18',UK:'22',AU:'22',EU:'50'} },
    { group:'5XL', sizes:['5XL'], bust:{cm:'122–129',in:'48–50'}, waist:{cm:'101–106',in:'40–43'}, hips:{cm:'126–131',in:'50–53'}, weight:null, cup:null, dress:{US:'20',UK:'24',AU:'24',EU:'52'} }
  ];

  var CHARTS = {
    'lingerie-set': { rows: ROWS_GROUPED,      grouped:true,  label:'Lingerie Set' },
    'bodysuit':     { rows: ROWS_GROUPED,      grouped:true,  label:'Bodysuit'     },
    'bodystocking': { rows: ROWS_BODYSTOCKING, grouped:true,  label:'Bodystocking' },
    'babydoll':     { rows: ROWS_BABYDOLL,     grouped:false, label:'Babydoll'     },
    'corset':       { rows: ROWS_CORSET,       grouped:false, label:'Corset'       }
  };

  /* ═══════════════════════════════════════════════════════════════
     SÉLECTEURS — du plus spécifique au plus générique.
     "Bra Size" contient "size", donc l'ordre compte.
     ═══════════════════════════════════════════════════════════════ */
  var SELECTOR_ROLES = [
    { role:'bottom',
      match:['thong & garter','thong and garter','thong','garter','panty','knicker','brief','bottom size','bas','culotte'] },
    { role:'bra',
      match:['bra size','bra','top size','cup size','soutien-gorge','haut'] },
    { role:'single',
      match:['size','taille','talla','größe','grösse','misura'] }
  ];

  /* ═══════════════════════════════════════════════════════════════
     NORMALISATION
     ═══════════════════════════════════════════════════════════════ */
  var SIZE_ALIASES = {
    'XXL':'2XL','XXXL':'3XL','XXXXL':'4XL','XXXXXL':'5XL','XXXXXXL':'6XL',
    '2X':'2XL','3X':'3XL','4X':'4XL','5X':'5XL','6X':'6XL',
    'EXTRA SMALL':'XS','SMALL':'S','MEDIUM':'M','LARGE':'L','EXTRA LARGE':'XL',
    'X-SMALL':'XS','X-LARGE':'XL'
  };

  function norm(v) {
    if (v === null || v === undefined) return '';
    return String(v).replace(/\u00A0/g,' ').replace(/[\u2010-\u2015]/g,'-')
                    .replace(/\s+/g,' ').trim().toUpperCase();
  }

  function canonSize(v) {
    var s = norm(v);
    if (!s) return '';
    if (SIZE_ALIASES[s]) return SIZE_ALIASES[s];
    s = s.replace(/\s*-\s*/g,'-').replace(/\s*\/\s*/g,'/');
    return SIZE_ALIASES[s] || s;
  }

  var _idx = {};
  function indexFor(chartId) {
    if (_idx[chartId]) return _idx[chartId];
    var chart = CHARTS[chartId] || CHARTS['lingerie-set'];
    var m = {};
    chart.rows.forEach(function (row) {
      row.sizes.forEach(function (s) { m[canonSize(s)] = row; });
      m[canonSize(row.group)] = row;
    });
    _idx[chartId] = m;
    return m;
  }

  function lookupRow(sizeValue) {
    var key = canonSize(sizeValue);
    var row = indexFor(ctx().chart)[key];
    if (!row && key && CFG.debug) {
      console.warn('[TF Fit] Taille inconnue "' + sizeValue + '" pour la grille "' + ctx().chart + '".');
    }
    return row || null;
  }

  /* ═══════════════════════════════════════════════════════════════
     CONTEXTE
     ═══════════════════════════════════════════════════════════════ */
  function ctx() {
    var c = window.TF_FIT || {};
    var sys = SYSTEMS[c.system] ? c.system : 'AU';
    return {
      system: sys,
      sys: SYSTEMS[sys],
      country: c.country || '',
      unit: SYSTEMS[sys].unit,
      weightUnit: SYSTEMS[sys].weight,
      chart: c.chart || 'lingerie-set',
      t: T[c.locale === 'fr' ? 'fr' : 'en']
    };
  }

  function layout() {
    return CFG.measureFirstSystems.indexOf(ctx().system) !== -1
      ? CFG.layouts.measureFirst : CFG.layouts.sizeFirst;
  }

  /* Les deux unités, dans l'ordre de l'habitude locale. */
  function measure(pair, unit) {
    if (!pair) return '';
    var main = unit === 'in' ? pair.in : pair.cm;
    if (!main) return '';
    var out = main + (unit === 'in' ? '"' : ' cm');
    if (CFG.showBothUnits) {
      var alt = unit === 'in' ? pair.cm : pair.in;
      if (alt) out += ' (' + alt + (unit === 'in' ? ' cm' : '"') + ')';
    }
    return out;
  }

  /* "140–175" lbs → "10–12½ st". Une Britannique pense en stones. */
  function toStones(lbsRange) {
    var m = String(lbsRange).match(/(\d+)\s*[–-]\s*(\d+)/);
    if (!m) return null;
    function st(lb) {
      var v = Math.round((lb / 14) * 2) / 2;
      return (v % 1 === 0) ? String(v) : (Math.floor(v) + '½');
    }
    return st(+m[1]) + '–' + st(+m[2]) + ' st';
  }

  /* "C/D" -> "C–D". Le fournisseur note ses plages de bonnets avec un
     slash, qui se lit "ou" alors qu'il signifie "de … à". */
  function formatCup(cup) {
    return String(cup).replace(/\s*\/\s*/g, '–');
  }

  function weightText(row, forceUnit, part) {
    if (!row.weight) return '';
    var w = (part && part.count > 1) ? API.splitWeight(row.weight, part.index, part.count) : row.weight;
    var u = forceUnit || ctx().weightUnit;
    if (u === 'st') { var st = toStones(w.lbs); return st || (w.lbs + ' lbs'); }
    if (u === 'lbs') return w.lbs + ' lbs';
    return w.kg + ' kg';
  }

  function fieldText(row, field, part) {
    var c = ctx();
    var n = (part && part.count) || 1, i = (part && part.index) || 0;
    var cut = function (f) { return n > 1 ? API.splitPair(row[f], i, n) : row[f]; };
    switch (field) {
      case 'dress':
        if (!row.dress || !row.dress[c.system]) return '';
        // Le Canada partage la colonne US mais doit lire "CA".
        var label = (c.country === 'CA') ? 'CA' : c.sys.label;
        // Sans découpe, XL et 2XL affichaient tous deux "UK 16–18".
        return label + ' ' + (n > 1 ? cutDress(row.dress[c.system], i, n) : row.dress[c.system]);
      case 'cup':
        // Le bonnet n'est pas découpé : une plage C/D signifie que le
        // vêtement accueille les deux, la scinder serait faux.
        // Le slash du fournisseur se lit "ou" ; c'est une plage, donc
        // un tiret. "C/D" devient "C–D".
        return row.cup ? (c.t.cup + formatCup(row.cup)) : '';
      case 'weight':
        if (CFG.weightOnCharts.indexOf(c.chart) === -1) return '';
        if (CFG.hideWeightOnSplitProducts && sizedWrappers().length > 1) return '';
        return weightText(row, null, part);
      case 'bust':  return row.bust  ? measure(cut('bust'),  c.unit) + c.t.bust  : '';
      case 'waist': return row.waist ? measure(cut('waist'), c.unit) + c.t.waist : '';
      case 'hips':  return row.hips  ? measure(cut('hips'),  c.unit) + c.t.hips  : '';
      default: return '';
    }
  }

  function composeLine(row, fields, part) {
    if (!fields || !fields.length) return '';
    var out = [];
    fields.forEach(function (f) { var t = fieldText(row, f, part); if (t) out.push(t); });
    return out.join(' · ');
  }

  function pairHint(row, currentSize) {
    if (!CFG.showPairHint) return '';
    if (!CHARTS[ctx().chart] || !CHARTS[ctx().chart].grouped) return '';
    var cur = canonSize(currentSize);
    var sib = row.sizes.filter(function (s) {
      var cs = canonSize(s);
      return cs !== cur && cs.indexOf('-') === -1 && cs.indexOf('/') === -1;
    });
    return sib.length ? ctx().t.pairHint.replace('{other}', sib.join(' / ')) : '';
  }

  /* ═══════════════════════════════════════════════════════════════
     DOM
     ═══════════════════════════════════════════════════════════════ */
  var _writing = false;

  /* TIFFANYA — PONT QUICKVIEW
     Racine imposée. Quand le quickview ouvre le guide, il pose ici son
     propre conteneur de formulaire : tout ce qui suit (tailles
     disponibles, rôles bra/bottom, sélection depuis le calculateur)
     travaille alors sur LE PRODUIT DU QUICKVIEW et non sur celui de la
     page. Remis à null à la fermeture. */
  var _qvScope = null;

  function allWrappers() {
    var root = (_qvScope && _qvScope.isConnected) ? _qvScope : document;
    var list = Array.prototype.slice.call(root.querySelectorAll('[data-select-label]'));
    // Hors scope imposé, on ignore tout ce qui appartient à un quickview.
    return _qvScope ? list : list.filter(function (w) { return !inQuickview(w); });
  }

  function roleFor(wrapper) {
    var label = (wrapper.getAttribute('data-select-label') || '').toLowerCase();
    for (var i = 0; i < SELECTOR_ROLES.length; i++) {
      for (var j = 0; j < SELECTOR_ROLES[i].match.length; j++) {
        if (label.indexOf(SELECTOR_ROLES[i].match[j]) !== -1) return SELECTOR_ROLES[i].role;
      }
    }
    return null;
  }

  function sizedWrappers() {
    return allWrappers().filter(function (w) { return !!roleFor(w); });
  }

  function checkedValue(wrapper) {
    var el = wrapper.querySelector('input[name^="options["]:checked');
    if (el) return el.value;
    var sel = wrapper.querySelector('select');
    return sel ? sel.value : null;
  }

  function ensureNodes(wrapper) {
    var host = wrapper.querySelector('fieldset') || wrapper;
    var out = {};
    [['note','tf-fit-note'], ['helper','tf-fit-helper']].forEach(function (p) {
      var el = wrapper.querySelector('.' + p[1]);
      if (!el) {
        el = document.createElement('p');
        el.className = p[1];
        el.setAttribute('data-morph-skip', '');
        host.appendChild(el);
      }
      out[p[0]] = el;
    });
    // Nettoie la ligne "Size up." des versions précédentes.
    if (!CFG.showTieBreak) {
      var old = wrapper.querySelector('.tf-fit-tip');
      if (old) old.remove();
    }
    return out;
  }

  function publishAvailableSizes() {
    var seen = {}, out = [];
    sizedWrappers().forEach(function (w) {
      w.querySelectorAll('input[name^="options["], select option').forEach(function (el) {
        var v = (el.value || '').trim();
        if (v && !seen[v]) { seen[v] = 1; out.push(v); }
      });
    });
    window.TF_FIT.availableSizes = out;
    return out;
  }

  function updateAll() {
    _writing = true;
    try {
      var c = ctx(), L = layout();
      sizedWrappers().forEach(function (wrapper) {
        var role  = roleFor(wrapper);
        var nodes = ensureNodes(wrapper);
        var value = checkedValue(wrapper);
        var row   = value ? lookupRow(value) : null;

        if (!row) { nodes.note.textContent = ''; nodes.helper.textContent = ''; return; }

        var part = API.partForSize(row, value);
        var l1 = composeLine(row, L.line1[role], part);
        var l2 = composeLine(row, L.line2[role], part);
        nodes.note.textContent   = (l1 ? c.t.fits + l1 : '') + pairHint(row, value);
        nodes.helper.textContent = l2;
      });
    } finally {
      setTimeout(function () { _writing = false; }, 0);
    }
  }

  /* TIFFANYA — CORRECTIF
     .tf-qv-root est un frère des sélecteurs de taille du quickview, pas
     leur parent : le test d'origine ne les attrapait donc jamais et le
     guide de la fiche produit écrivait ses notes DANS le quickview
     (mauvaises tailles sur « View & Save »). On teste maintenant les
     conteneurs qui englobent réellement le formulaire du quickview. */
  var QV_SELECTOR = '.tf-qv-root,[data-quickview-form-area],[data-quickview-modal],.quickview__modal';

  function inQuickview(el) {
    return !!(el && el.closest && el.closest(QV_SELECTOR));
  }

  /* Cible du bouton : "Bra Size" en priorité, sinon "Size", sinon tout
     libellé contenant "size" qui n'est ni le thong ni le garter. */
  function triggerTarget() {
    var all = Array.prototype.slice
      .call(document.querySelectorAll('[data-select-label]'))
      .filter(function (w) { return !inQuickview(w); });
    function find(fn) {
      for (var i = 0; i < all.length; i++) {
        var l = (all[i].getAttribute('data-select-label') || '').trim().toLowerCase();
        if (fn(l)) return all[i];
      }
      return null;
    }
    return find(function (l) { return l === 'bra size'; })
        || find(function (l) { return l === 'size'; })
        || find(function (l) {
             return l.indexOf('size') > -1 &&
                    l.indexOf('thong') === -1 && l.indexOf('garter') === -1;
           });
  }

  function moveSizeChartTrigger() {
    // Une autre modale place déjà son bouton : ne pas en ajouter un second.
    if (API.foreignModal && API.foreignModal()) return true;

    var target = triggerTarget();
    var legend = target && target.querySelector('.radio__legend');
    var source = document.querySelector('#tf-trigger-container .tf-sg-open');
    if (!source) return false;

    if (legend) {
      var existing = legend.querySelectorAll('.tf-sg-open');
      // Dédoublonnage : le thème re-render, on peut se retrouver avec
      // plusieurs copies du même bouton dans la légende.
      for (var i = 1; i < existing.length; i++) existing[i].remove();
      if (!existing.length) {
        var btn = source.cloneNode(true);
        btn.setAttribute('data-morph-skip', '');
        legend.appendChild(btn);
      }
      var info = document.querySelector('#tf-trigger-container .tf-model-info');
      var fs = target.querySelector('.radio__fieldset');
      if (info && fs && !fs.querySelector('.tf-model-info')) {
        var c2 = info.cloneNode(true);
        c2.setAttribute('data-morph-skip', '');
        fs.appendChild(c2);
      }
      return true;
    }

    // Repli : pas de légende trouvée, on pose le bouton en tête du
    // formulaire d'ajout au panier plutôt que de ne rien afficher.
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && !form.querySelector('.tf-sg-open')) {
      var fb = source.cloneNode(true);
      fb.setAttribute('data-morph-skip', '');
      form.insertBefore(fb, form.firstChild);
      return true;
    }
    return false;
  }

  /* Le bloc produit est re-rendu à chaque changement de variante :
     on relance le placement tant qu'il n'a pas abouti. */
  function armTrigger() {
    if (moveSizeChartTrigger()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (moveSizeChartTrigger() || ++tries > 12) clearInterval(iv);
    }, 400);
  }


  /* ═══════════════════════════════════════════════════════════════
     API PUBLIQUE — consommée par le fichier 2 (modale)
     ═══════════════════════════════════════════════════════════════ */
  var API = window.TF_FIT;

  API.SYSTEMS = SYSTEMS;

  /* SOURCE UNIQUE. Le tableau et le calculateur lisent ceci. */
  API.getRows = function () {
    return (CHARTS[ctx().chart] || CHARTS['lingerie-set']).rows;
  };

  API.chartInfo = function () {
    var ch = CHARTS[ctx().chart] || CHARTS['lingerie-set'];
    return { id: ctx().chart, label: ch.label, grouped: ch.grouped };
  };

  API.systemInfo = function () {
    var c = ctx();
    return {
      key: c.system,
      label: (c.country === 'CA') ? 'CA' : c.sys.label,
      tab: c.sys.tab,
      unit: c.unit,
      weightUnit: c.weightUnit,
      fromSupplier: c.sys.supplier,
      countries: c.sys.countries
    };
  };

  API.roles = function () {
    return sizedWrappers().map(roleFor);
  };

  /* TIFFANYA — PONT QUICKVIEW : bascule de portée.
     setScope(el)    -> tout le moteur lit le formulaire du quickview
     releaseScope()  -> retour à la fiche produit
     refreshSizes()  -> recalcule availableSizes dans la portée courante */
  API.setScope = function (el) { _qvScope = el || null; };
  API.releaseScope = function () { _qvScope = null; };
  API.refreshSizes = publishAvailableSizes;

  /* TIFFANYA — PONT QUICKVIEW : notes « Fits: » d'un AUTRE produit.
     Écrit les notes du produit du quickview, avec SA grille et SES
     tailles, puis restaure immédiatement le contexte de la fiche.
     Même source que la fiche produit — aucune table dupliquée.
     Synchrone : à la sortie, rien n'a bougé côté page. */
  API.notesFor = function (cfg) {
    cfg = cfg || {};
    if (!cfg.scope) return false;
    var saved = {
      chart: API.chart, system: API.system, country: API.country,
      locale: API.locale, sizes: API.availableSizes, scope: _qvScope
    };
    try {
      _qvScope = cfg.scope;
      if (cfg.chart)   API.chart = cfg.chart;
      if (cfg.system)  API.system = cfg.system;
      if (cfg.country) API.country = cfg.country;
      if (cfg.locale)  API.locale = cfg.locale;
      publishAvailableSizes();
      updateAll();
      return true;
    } finally {
      _qvScope = saved.scope;
      API.chart = saved.chart;
      API.system = saved.system;
      API.country = saved.country;
      API.locale = saved.locale;
      API.availableSizes = saved.sizes;
    }
  };

  API.measureText = function (row, field, unit) {
    return measure(row[field], unit || ctx().unit);
  };

  API.weightText = weightText;
  API.formatCup  = formatCup;

  /* Mesure en cm → ligne de grille.
     Applique la règle affichée dans la modale : sur une borne exacte,
     on prend la taille au-dessus. Renvoie aussi si on est hors gamme. */
  API.rowForMeasure = function (field, cmValue) {
    var rows = API.ladderRows(), v = parseFloat(cmValue);
    if (isNaN(v)) return null;
    var bounds = API.rangeFor(field);
    if (!bounds) return null;
    // La mesure et le champ voyagent avec le résultat : ils servent à
    // choisir la taille exacte à l'intérieur du groupe.
    if (v < bounds.min) return { row: rows[0], below: true, value: v, field: field };
    if (v > bounds.max) return { row: rows[rows.length - 1], above: true, value: v, field: field };
    for (var i = 0; i < rows.length; i++) {
      var p = rows[i][field]; if (!p || !p.cm) continue;
      var m = p.cm.match(/(\d+)\s*[–-]\s*(\d+)/); if (!m) continue;
      if (v < +m[2]) return { row: rows[i], value: v, field: field };  // borne haute → taille au-dessus
    }
    return { row: rows[rows.length - 1], value: v, field: field };
  };

  /* L'échelle de tailles exclut la ligne "Free Size" : sa fourchette
     chevauche XS-S et M-L, donc elle capturait toutes les mesures
     basses et le calculateur ne trouvait plus aucune taille. Elle
     n'est réintroduite que sur les fiches vendues en taille unique. */
  API.ladderRows = function () {
    var rows = API.getRows();
    var ladder = rows.filter(function (r) { return !r.oneSize; });
    return ladder.length ? ladder : rows;
  };

  API.rangeFor = function (field) {
    var rows = API.ladderRows(), min = null, max = null;
    rows.forEach(function (r) {
      var p = r[field]; if (!p || !p.cm) return;
      var m = p.cm.match(/(\d+)\s*[–-]\s*(\d+)/); if (!m) return;
      if (min === null || +m[1] < min) min = +m[1];
      if (max === null || +m[2] > max) max = +m[2];
    });
    return (min === null) ? null : { min: min, max: max };
  };

  /* ═══════════════════════════════════════════════════════════════
     DÉCOUPE DES LIGNES GROUPÉES

     Problème : XL et 2XL partagent une ligne de charte, donc le tableau
     affichait deux fois "40–44" bust · UK 16–18". Une cliente n'a alors
     aucun moyen de choisir, et doute de tout le tableau.

     Solution : quand une fiche propose les DEUX tailles d'un groupe, on
     coupe la fourchette en deux. Ce n'est pas une invention — couper en
     deux les fourchettes groupées (images 2+4) redonne exactement la
     charte individuelle du fournisseur (image 3) : 40 valeurs vérifiées
     sur bust, waist, hips et taille de robe, zéro écart.

     Quand une seule taille du groupe est vendue, aucune découpe : la
     fourchette complète est affichée, ce qui est plus juste et évite de
     perdre des ventes en bord de gamme.

     Le vêtement, lui, couvre toujours tout le groupe : une découpe ne
     peut donc pas provoquer d'erreur de taille, seulement guider le
     choix entre deux étiquettes du même article.
     ═══════════════════════════════════════════════════════════════ */

  function cutRange(str, idx, n) {
    if (n < 2) return str;
    var m = String(str).match(/(\d+(?:\.\d+)?)\s*[–-]\s*(\d+(?:\.\d+)?)/);
    if (!m) return str;
    var lo = parseFloat(m[1]), hi = parseFloat(m[2]);
    var a = Math.round(lo + (hi - lo) * idx / n);
    var b = Math.round(lo + (hi - lo) * (idx + 1) / n);
    return a + '–' + b;
  }

  /* Taille de robe : valeurs discrètes, pas une fourchette continue.
     UK "16–18" sur deux tailles → 16 puis 18. */
  function cutDress(str, idx, n) {
    if (n < 2) return str;
    var m = String(str).match(/(\d+)\s*[–-]\s*(\d+)/);
    if (!m) return str;
    var lo = +m[1], hi = +m[2];
    return String(Math.round(lo + (hi - lo) * idx / (n - 1)));
  }

  API.splitPair = function (pair, idx, n) {
    if (!pair || n < 2) return pair;
    return { cm: cutRange(pair.cm, idx, n), in: cutRange(pair.in, idx, n) };
  };

  API.splitWeight = function (w, idx, n) {
    if (!w || n < 2) return w;
    return { kg: cutRange(w.kg, idx, n), lbs: cutRange(w.lbs, idx, n) };
  };

  API.splitDress = cutDress;

  /* Position d'une taille parmi celles du MÊME groupe réellement
     vendues sur cette fiche. count = 1 → pas de découpe. */
  API.partForSize = function (row, sizeValue) {
    if (!row || !CFG.splitGroupedRows) return { index: 0, count: 1 };
    var avail = (API.availableSizes || []).map(canonSize);
    var present = row.sizes.filter(function (sz) {
      var c = canonSize(sz);
      return c.indexOf('-') === -1 && c.indexOf('/') === -1 && avail.indexOf(c) !== -1;
    }).map(canonSize);
    var i = present.indexOf(canonSize(sizeValue));
    if (i === -1 || present.length < 2) return { index: 0, count: 1 };
    return { index: i, count: present.length };
  };

  /* Ligne de grille → taille individuelle réellement proposée.

     L'ancienne règle renvoyait toujours la PREMIÈRE taille disponible
     du groupe. Conséquence : sur une fiche L→4XL, le calculateur ne
     pouvait sortir que L, XL et 3XL. 2XL et 4XL étaient structurellement
     inatteignables.

     Désormais la position de la mesure dans la fourchette décide : moitié
     basse → première taille du groupe, moitié haute → seconde. Le
     vêtement reçu est le même dans les deux cas (c'est la charte
     fournisseur), donc aucun risque sur la coupe — mais toutes vos
     variantes redeviennent accessibles, et les commandes se répartissent
     entre les deux SKU au lieu de s'entasser sur le premier.

     edge : 'min' ou 'max' force le bord du groupe, utilisé quand on
     rabat une mesure hors gamme sur la taille la plus proche. */
  function originalCase(canon) {
    var avail = API.availableSizes || [];
    for (var i = 0; i < avail.length; i++) {
      if (canonSize(avail[i]) === canon) return avail[i];
    }
    return null;
  }

  API.sizeForRow = function (row, cmValue, field, edge) {
    if (!row) return null;
    var avail = (API.availableSizes || []).map(canonSize);

    var present = row.sizes.filter(function (sz) {
      var c = canonSize(sz);
      return c.indexOf('-') === -1 && c.indexOf('/') === -1 && avail.indexOf(c) !== -1;
    }).map(canonSize);

    if (!present.length) return null;
    if (present.length === 1) return originalCase(present[0]);
    if (edge === 'min') return originalCase(present[0]);
    if (edge === 'max') return originalCase(present[present.length - 1]);

    var pair = field && row[field];
    var v = parseFloat(cmValue);
    if (!pair || !pair.cm || isNaN(v)) return originalCase(present[0]);

    var m = String(pair.cm).match(/(\d+)\s*[–-]\s*(\d+)/);
    if (!m) return originalCase(present[0]);
    var lo = +m[1], hi = +m[2];
    if (hi <= lo) return originalCase(present[0]);

    var t = Math.min(0.9999, Math.max(0, (v - lo) / (hi - lo)));
    return originalCase(present[Math.floor(t * present.length)]);
  };

  /* Ligne la plus proche qui propose au moins une taille sur cette
     fiche. Sans ça, une mesure au-delà de la plus grande taille du
     produit affichait "cette taille n'est pas proposée" au lieu de
     rabattre sur la plus grande disponible. */
  API.nearestAvailableRow = function (row) {
    var rows = API.ladderRows();
    var i = rows.indexOf(row);
    if (i === -1) return null;
    if (API.sizeForRow(row)) return row;
    for (var d = 1; d < rows.length; d++) {
      if (rows[i - d] && API.sizeForRow(rows[i - d])) return rows[i - d];
      if (rows[i + d] && API.sizeForRow(rows[i + d])) return rows[i + d];
    }
    return null;
  };

  API.rowForSize = lookupRow;
  API.canonSize  = canonSize;

  /* Onglets de région de la modale. */
  API.setSystem = function (key) {
    if (!SYSTEMS[key]) return;
    window.TF_FIT.system = key;
    updateAll();
    document.dispatchEvent(new CustomEvent('tf:region-change', { detail: API.systemInfo() }));
  };

  /* ═══════════════════════════════════════════════════════════════
     APPLICATION DES TAILLES DEPUIS LE CALCULATEUR

     Trois pièges, tous rencontrés :

     1. Cliquer l'<input> ne suffit pas. Le thème écoute le <label> ;
        cocher la radio directement change l'apparence sans déclencher
        la mise à jour de variante — le formulaire garde l'ancien id et
        c'est lui qui part au panier.

     2. Le bloc produit est re-rendu après chaque changement. Toute
        référence DOM capturée avant devient obsolète : il faut
        re-chercher le nœud à chaque tentative.

     3. Haut et bas ne peuvent pas être appliqués en parallèle. Changer
        le haut détruit les nœuds du bas ; les lancer ensemble revenait
        à écrire dans un DOM périmé. D'où l'enchaînement séquentiel avec
        vérification à chaque étape.
     ═══════════════════════════════════════════════════════════════ */

  function findSizeInput(role, sizeValue) {
    var target = canonSize(sizeValue), found = null;
    sizedWrappers().forEach(function (w) {
      if (found || roleFor(w) !== role) return;
      w.querySelectorAll('input[name^="options["]').forEach(function (i) {
        if (!found && canonSize(i.value) === target) found = i;
      });
    });
    return found;
  }

  function findSizeSelect(role) {
    var found = null;
    sizedWrappers().forEach(function (w) {
      if (!found && roleFor(w) === role) found = w.querySelector('select');
    });
    return found;
  }

  /* Le label est ce qu'une cliente touche réellement. */
  function clickTargetFor(input) {
    var lab = null;
    try {
      if (input.id) {
        var sel = (window.CSS && CSS.escape) ? CSS.escape(input.id) : input.id;
        lab = document.querySelector('label[for="' + sel + '"]');
      }
    } catch (e) {}
    return lab || (input.closest && input.closest('label')) || input;
  }

  function isSelected(role, sizeValue) {
    var input = findSizeInput(role, sizeValue);
    if (input) return !!input.checked;
    var sel = findSizeSelect(role);
    return !!(sel && canonSize(sel.value) === canonSize(sizeValue));
  }

  /* Applique UNE taille, en vérifiant que la coche a bien pris. */
  API.selectSize = function (role, sizeValue, done) {
    done = done || function () {};
    var tries = 0;

    (function attempt() {
      if (isSelected(role, sizeValue)) return done(true);

      var input = findSizeInput(role, sizeValue);
      if (input) {
        clickTargetFor(input).click();
        return setTimeout(function () {
          if (isSelected(role, sizeValue)) return done(true);
          return (++tries < 10) ? setTimeout(attempt, 150) : done(false);
        }, 190);
      }

      var sel = findSizeSelect(role);
      if (sel) {
        for (var j = 0; j < sel.options.length; j++) {
          if (canonSize(sel.options[j].value) === canonSize(sizeValue)) {
            sel.selectedIndex = j;
            sel.dispatchEvent(new Event('input',  { bubbles: true }));
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            return setTimeout(function () { done(isSelected(role, sizeValue)); }, 190);
          }
        }
      }

      // Sélecteur pas encore monté : on repasse.
      return (++tries < 10) ? setTimeout(attempt, 150) : done(false);
    })();
  };

  /* Applique le plan complet, séquentiellement, puis revérifie tout.
     La vérification finale compte : appliquer le bas re-rend le bloc et
     peut réinitialiser le haut. Une seconde passe rattrape ce cas. */
  API.applySizes = function (plan, done) {
    done = done || function () {};

    function runPass(cb) {
      var ok = true;
      (function step(i) {
        if (i >= plan.length) return cb(ok);
        API.selectSize(plan[i][0], plan[i][1], function (good) {
          if (!good) ok = false;
          setTimeout(function () { step(i + 1); }, 120);
        });
      })(0);
    }

    function allSelected() {
      return plan.every(function (p) { return isSelected(p[0], p[1]); });
    }

    runPass(function () {
      if (allSelected()) return done(true);
      // Seconde passe : le re-render a défait une des sélections.
      runPass(function () { done(allSelected()); });
    });
  };

  /* Identifiant de variante réellement armé dans le formulaire.
     C'est lui qui part au panier — s'il ne bouge pas, la sélection
     visuelle ne veut rien dire. Exposé pour diagnostic. */
  API.currentVariantId = function () {
    var f = document.querySelector('form[action*="/cart/add"]');
    var i = f && f.querySelector('input[name="id"], select[name="id"]');
    return i ? String(i.value) : null;
  };

  API.scrollToSelectors = function () {
    var w = sizedWrappers()[0];
    if (w && w.scrollIntoView) w.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  /* Confirmation visuelle : la cliente doit voir où sa taille a atterri. */
  API.flashSelectors = function () {
    sizedWrappers().forEach(function (w) {
      w.style.transition = 'box-shadow .3s ease';
      w.style.boxShadow = '0 0 0 3px rgba(107,27,46,.35)';
      setTimeout(function () { w.style.boxShadow = ''; }, 1200);
    });
  };

  /* ═══════════════════════════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════════════════════════ */
  /* TIFFANYA — PONT QUICKVIEW
     qvOnly : le script a été chargé à la demande par le quickview sur
     une page qui n'est PAS une fiche produit plus size (collection,
     panier, fiche standard). Il ne doit alors rien peindre sur la page
     — ni bouton, ni note « Fits: » — et se contenter d'exposer l'API
     pour la modale du quickview. */
  function refresh() {
    if (window.TF_FIT && window.TF_FIT.qvOnly) return;
    publishAvailableSizes(); updateAll(); armTrigger();
  }

  function init() {
    API.refreshAll = refresh;   // TIFFANYA : restauration après quickview
    refresh();

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches &&
          (e.target.matches('input[name^="options["]') || e.target.matches('select'))) {
        setTimeout(updateAll, 30);
      }
    });

    var container = document.querySelector('[data-product-form-wrapper], .product-info');
    if (container && window.MutationObserver) {
      new MutationObserver(function () {
        if (_writing) return;
        clearTimeout(window.__tfFitDebounce);
        window.__tfFitDebounce = setTimeout(refresh, 120);
      }).observe(container, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', refresh);
    document.dispatchEvent(new CustomEvent('tf:ready'));
    window.TF_FIT.ready = true;

    if (CFG.debug) {
      var c = ctx();
      console.log('[TF Fit] grille =', c.chart, '| système =', c.system,
                  '| pays =', c.country, '| unité =', c.unit,
                  '| sélecteurs =', API.roles(), '| tailles =', API.availableSizes);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();

/* ═══════════════════════════════════════════════════════════════════
   2. MODALE — tableau + calculateur
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var STORAGE_KEY = 'tf_sg_measures_v6';

  var _parked = false;

  function start() {
    var API = window.TF_FIT;
    if (!API || typeof API.getRows !== 'function') { return setTimeout(start, 60); }

    /* TIFFANYA — PONT QUICKVIEW
       Une autre modale tient la fiche produit : on ne s'installe pas,
       mais on ne renonce plus définitivement. Si le quickview appelle
       TF_FIT.mountForce() pour un produit plus size, l'événement
       'tf:sg:mounted' nous réveille et on se câble à ce moment-là. */
    if (API.modalDisabled && !document.getElementById('tf-sg-overlay')) {
      if (!_parked) {
        _parked = true;
        console.info('[TF Fit] Une autre modale de tailles est présente : ' +
                     'seules les notes "Fits:" sont actives. ' +
                     'Forcer celle-ci : window.TF_SG_FORCE = true;');
        document.addEventListener('tf:sg:mounted', function once () {
          document.removeEventListener('tf:sg:mounted', once);
          _parked = false;
          start();
        });
      }
      return;
    }
    if (!document.getElementById('tf-sg-overlay')) { return setTimeout(start, 60); }

    // Un seul câblage, même si start() est rappelé après un mountForce().
    if (window.__TF_SG_MODAL_WIRED) return;
    window.__TF_SG_MODAL_WIRED = true;

    /* ─── Éléments ─────────────────────────────────────────────── */
    var overlay   = document.getElementById('tf-sg-overlay');
    var closeBtn  = document.getElementById('tf-sg-close');
    var tabChart  = document.getElementById('tf-tab-chart');
    var tabCalc   = document.getElementById('tf-tab-calc');
    var panChart  = document.getElementById('tf-panel-chart');
    var panCalc   = document.getElementById('tf-panel-calc');
    var regionBox = document.getElementById('tf-sg-regions');
    var regionNote= document.getElementById('tf-sg-region-note');
    var tableEl   = document.getElementById('tf-sg-table');
    var headingEl = document.getElementById('tf-sg-chart-heading');
    var twoBox    = document.getElementById('tf-sg-twobox');
    var fineEl    = document.getElementById('tf-sg-fine');
    var fieldsEl  = document.getElementById('tf-sg-fields');
    var resultEl  = document.getElementById('tf-sg-result');
    var unitCm    = document.getElementById('tf-unit-cm');
    var unitIn    = document.getElementById('tf-unit-in');

    /* Les 4 onglets. UK et AU/NZ portent les mêmes nombres (colonne
       fournisseur "UK/AU") mais pas les mêmes unités. L'onglet EU
       regroupe trois conventions incompatibles, affichées côte à côte. */
    /* Quatre onglets, desktop comme mobile. UK et AU/NZ portent les
       mêmes nombres (colonne fournisseur "UK/AU") mais pas les mêmes
       unités : pouces + stones d'un côté, cm + kg de l'autre. */
    var TABS = [
      { id:'UK', label:'UK',      systems:['UK'], unit:'in', weight:'st'  },
      { id:'US', label:'US / CA', systems:['US'], unit:'in', weight:'lbs' },
      { id:'AU', label:'AU / NZ', systems:['AU'], unit:'cm', weight:'kg'  },
      { id:'EU', label:'EUR',     systems:['EU'], unit:'cm', weight:'kg'  }
    ];

    var SYS_HEAD = {
      UK:{h:'UK',      sub:'United Kingdom · Ireland'},
      US:{h:'US / CA', sub:'United States · Canada'},
      AU:{h:'AU / NZ', sub:'Australia · New Zealand'},
      EU:{h:'EUR',     sub:'Europe'}
    };

    var homeSystem   = API.homeSystem || 'AU';
    var activeSystem = homeSystem;
    var activeTab    = null;

    /* L'onglet se déduit du système actif et du jeu courant : passer de
       desktop à mobile (ou tourner le téléphone) conserve le choix. */
    function syncTab() {
      var set = TABS;
      activeTab = null;
      for (var i = 0; i < set.length && !activeTab; i++) {
        if (set[i].systems.indexOf(activeSystem) !== -1) activeTab = set[i];
      }
      if (!activeTab) { activeTab = set[0]; activeSystem = activeTab.systems[0]; }
    }
    syncTab();

    var calcUnit = activeTab.unit;
    var measures = { bust:null, waist:null, hips:null };

    /* ─── Rendu des pastilles de région ─────────────────────────── */
    function renderRegions() {
      syncTab();
      regionBox.innerHTML = '';
      TABS.forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tf-sg-region';
        b.textContent = t.label;
        b.setAttribute('aria-pressed', t.id === activeTab.id ? 'true' : 'false');
        b.addEventListener('click', function () {
          // Sur l'onglet groupé, on garde la convention du pays réel
          // si elle en fait partie.
          activeSystem = t.systems.indexOf(homeSystem) !== -1 ? homeSystem : t.systems[0];
          syncTab();
          API.setSystem(activeSystem);
          calcUnit = activeTab.unit;
          renderAll();
        });
        regionBox.appendChild(b);
      });

      // Les sous-titres de pays sont masqués dans l'en-tête du tableau
      // sur mobile : ils reviennent ici, sur une seule ligne.
      var isHome = activeTab.systems.indexOf(homeSystem) !== -1;
      var sub = (activeTab.systems.length === 1 && SYS_HEAD[activeTab.systems[0]])
        ? SYS_HEAD[activeTab.systems[0]].sub : '';
      regionNote.textContent = isHome
        ? (sub ? sub + ' — tap to switch.' : 'Region auto-detected — tap to switch.')
        : (sub || activeTab.label);
    }

    /* ─── Tableau ───────────────────────────────────────────────── */
    function cellMeasure(row, field, part) {
      var p = row[field];
      if (part && part.count > 1) p = API.splitPair(p, part.index, part.count);
      if (!p) return '—';
      var main = activeTab.unit === 'in' ? p.in : p.cm;
      var alt  = activeTab.unit === 'in' ? p.cm : p.in;
      var mu   = activeTab.unit === 'in' ? '"'  : '';
      var au   = activeTab.unit === 'in' ? ' cm': '"';
      return main + mu + '<span class="tf-sg-alt">' + alt + au + '</span>';
    }

    function cellWeight(row, part) {
      if (!row.weight) return '—';
      var w = (part && part.count > 1)
        ? API.splitWeight(row.weight, part.index, part.count) : row.weight;
      if (activeTab.weight === 'st') {
        return API.weightText(row, 'st', part) + '<span class="tf-sg-alt">' + w.kg + ' kg</span>';
      }
      if (activeTab.weight === 'lbs') {
        return w.lbs + ' lbs<span class="tf-sg-alt">' + w.kg + ' kg</span>';
      }
      return w.kg + ' kg<span class="tf-sg-alt">' + w.lbs + ' lbs</span>';
    }

    /* Une ligne par taille INDIVIDUELLE réellement proposée sur la
       fiche : plus de "XL-2XL" en face de boutons "XL" et "2XL". */
    function displayRows() {
      var rows = API.getRows();
      var avail = (API.availableSizes || []).slice();
      var out = [];
      if (!avail.length) {
        rows.forEach(function (r) { out.push({ label:r.group, row:r, twin:false }); });
        return out;
      }
      rows.forEach(function (r) {
        var keys = r.sizes.map(API.canonSize);
        var mine = avail.filter(function (v) { return keys.indexOf(API.canonSize(v)) !== -1; });
        mine.forEach(function (v, i) {
          out.push({ label:v, row:r, twin: false,
                     part: { index:i, count: mine.length } });
        });
      });
      return out;
    }

    function renderTable() {
      var rows  = API.getRows();
      var info  = API.chartInfo();
      var disp  = displayRows();
      var hasW  = rows.some(function (r) { return !!r.weight; });
      var hasC  = rows.some(function (r) { return !!r.cup; });
      var hasD  = rows.some(function (r) { return !!r.dress; });
      var uLab  = activeTab.unit === 'in' ? 'in / cm' : 'cm / in';
      var wLab  = activeTab.weight === 'st' ? 'st / kg'
                : activeTab.weight === 'lbs' ? 'lbs / kg' : 'kg / lbs';

      headingEl.textContent = info.label + ' sizes';

      var head = '<thead><tr><th class="c-size">Size</th>' +
        '<th class="c-m">Bust<span>' + uLab + '</span></th>' +
        '<th class="c-m">Waist<span>' + uLab + '</span></th>' +
        '<th class="c-m">Hips<span>' + uLab + '</span></th>';
      if (hasW) head += '<th class="c-w">Weight<span>' + wLab + '</span></th>';
      if (hasC) head += '<th class="c-cup">Cups<span>fits</span></th>';
      if (hasD) activeTab.systems.forEach(function (sy) {
        head += '<th class="c-reg">' + SYS_HEAD[sy].h + '<span>' + SYS_HEAD[sy].sub + '</span></th>';
      });
      head += '</tr></thead>';

      var body = '<tbody>';
      disp.forEach(function (d) {
        body += '<tr' + (d.twin ? ' class="tf-sg-twin"' : '') + '>';
        // Une classe par colonne : le CSS mobile masque la plus large
        // (Weight) sur les petits écrans et fige la colonne Size.
        function td(cls, value) { return '<td class="' + cls + '">' + value + '</td>'; }
        var pt = d.part || { index:0, count:1 };
        body += td('c-size', d.label);
        body += td('c-m', cellMeasure(d.row, 'bust',  pt));
        body += td('c-m', cellMeasure(d.row, 'waist', pt));
        body += td('c-m', cellMeasure(d.row, 'hips',  pt));
        if (hasW) body += td('c-w', cellWeight(d.row, pt));
        if (hasC) body += td('c-cup', d.row.cup ? API.formatCup(d.row.cup) : '—');
        if (hasD) activeTab.systems.forEach(function (sy) {
          var dv = d.row.dress && d.row.dress[sy];
          body += td('c-reg', dv ? API.splitDress(dv, pt.index, pt.count) : '—');
        });
        body += '</tr>';
      });
      tableEl.innerHTML = head + (body + '</tbody>');

      var roles = API.roles();
      twoBox.hidden = !(roles.indexOf('bra') !== -1 && roles.indexOf('bottom') !== -1);

      // La colonne EUR du fournisseur suit la convention FR/ES. Les
      // conventions allemande et italienne diffèrent : on le dit, sans
      // fabriquer de colonnes que le fournisseur ne fournit pas.
      fineEl.textContent = (activeTab.id === 'EU')
        ? 'EUR follows French and Spanish sizing. Elsewhere in Europe, go by the measurements \u2014 they are the same everywhere.'
        : '';
    }

    /* ─── Calculateur ───────────────────────────────────────────── */
    var FIELDS = [
      { key:'bust',  label:'Bust'  },
      { key:'waist', label:'Waist' },
      { key:'hips',  label:'Hips'  }
    ];

    function toDisplay(cm) {
      return calcUnit === 'in' ? Math.round(cm / 2.54) : Math.round(cm);
    }
    function fromDisplay(v) {
      return calcUnit === 'in' ? v * 2.54 : v;
    }

    function renderFields() {
      unitCm.setAttribute('aria-pressed', calcUnit === 'cm' ? 'true' : 'false');
      unitIn.setAttribute('aria-pressed', calcUnit === 'in' ? 'true' : 'false');

      fieldsEl.innerHTML = '';
      FIELDS.forEach(function (f) {
        var range = API.rangeFor(f.key);
        if (!range) return;
        if (measures[f.key] === null) measures[f.key] = Math.round((range.min + range.max) / 2);

        var lo = toDisplay(range.min), hi = toDisplay(range.max);
        var val = Math.min(hi, Math.max(lo, toDisplay(measures[f.key])));
        var u = calcUnit === 'in' ? 'in' : 'cm';

        var wrap = document.createElement('div');
        wrap.className = 'tf-sg-field';
        wrap.innerHTML =
          '<div class="tf-sg-fieldhead">' +
            '<span class="tf-sg-label">' + f.label + '</span>' +
            '<span class="tf-sg-numwrap">' +
              '<button type="button" class="tf-sg-step" data-step="-1" aria-label="Decrease ' + f.label + '">&minus;</button>' +
              '<input type="number" class="tf-sg-num" value="' + val + '" inputmode="numeric" aria-label="' + f.label + ' in ' + u + '">' +
              '<button type="button" class="tf-sg-step" data-step="1" aria-label="Increase ' + f.label + '">+</button>' +
              '<span class="tf-sg-numunit">' + u + '</span>' +
            '</span>' +
          '</div>' +
          '<div class="tf-sg-slider">' +
            '<input type="range" class="tf-sg-range" min="' + lo + '" max="' + hi + '" step="1" value="' + val + '" aria-label="' + f.label + '">' +
          '</div>' +
          '<div class="tf-sg-scale"><span>' + lo + ' ' + u + '</span><span>' + hi + ' ' + u + '</span></div>';

        var slider = wrap.querySelector('.tf-sg-range');
        var num    = wrap.querySelector('.tf-sg-num');

        // La portion parcourue est peinte en bordeaux via une variable
        // CSS : un input range natif ne sait pas le faire seul.
        function paint(v) {
          var pct = hi > lo ? ((v - lo) / (hi - lo)) * 100 : 0;
          slider.style.setProperty('--tf-pct', pct.toFixed(2));
        }

        function commit(v, syncSlider, syncNum) {
          var clamped = Math.min(hi, Math.max(lo, v));
          measures[f.key] = fromDisplay(clamped);
          if (syncSlider) slider.value = clamped;
          if (syncNum) num.value = clamped;
          paint(clamped);
          save(); renderResult();
        }

        slider.addEventListener('input', function () { commit(+slider.value, false, true); });
        num.addEventListener('input', function () {
          var v = parseFloat(num.value);
          if (!isNaN(v)) commit(v, true, false);
        });
        num.addEventListener('blur', function () { num.value = toDisplay(measures[f.key]); });
        wrap.querySelectorAll('.tf-sg-step').forEach(function (btn) {
          btn.addEventListener('click', function () {
            commit((parseFloat(num.value) || 0) + (+btn.getAttribute('data-step')), true, true);
          });
        });

        paint(val);
        fieldsEl.appendChild(wrap);
      });
    }

    /* Renvoie la taille à afficher. Si la mesure tombe au-delà (ou en
       deçà) de ce que la fiche propose, on rabat sur la taille la plus
       proche réellement vendue et on le signale, plutôt que d'afficher
       un tiret et un message d'échec. */
    function sizeLabel(res) {
      if (!res || !res.row) return null;
      var direct = API.sizeForRow(res.row, res.value, res.field);
      if (direct) return direct;

      var alt = API.nearestAvailableRow(res.row);
      if (!alt) return null;

      var rows = API.ladderRows();
      var edge = rows.indexOf(alt) < rows.indexOf(res.row) ? 'max' : 'min';
      res.clamped = edge;
      return API.sizeForRow(alt, null, res.field, edge);
    }

    /* Le bas se règle sur la plus contraignante des deux mesures :
       un porte-jarretelles tient à la taille, la culotte aux hanches. */
    function bottomResult() {
      var rows = API.ladderRows();
      var w = API.rowForMeasure('waist', measures.waist);
      var h = API.rowForMeasure('hips',  measures.hips);
      if (!w) return h;
      if (!h) return w;
      return rows.indexOf(w.row) >= rows.indexOf(h.row) ? w : h;
    }

    function renderResult() {
      var roles = API.roles();
      var split = roles.indexOf('bra') !== -1 && roles.indexOf('bottom') !== -1;

      var topRes = API.rowForMeasure('bust', measures.bust);
      var botRes = bottomResult();

      var topSize = sizeLabel(topRes);
      var botSize = sizeLabel(botRes);

      var warn = [];
      // Sous la gamme : ce style commence au L (UK 12). Une cliente plus
      // petite est renvoyée vers les collections standard (XS–XL) au lieu
      // d'être poussée vers un L curvy qui ne lui ira pas.
      var smallerUrl  = API.smallerSizesUrl  || '/collections/lingerie-sets';
      var smallerUrl2 = API.smallerSizesUrl2 || '/collections/bodysuits';
      var smallestLabel = (API.availableSizes && API.availableSizes.length) ? API.availableSizes[0] : 'L';
      var smallerLink = ' This style starts at <strong>' + smallestLabel + '</strong>. For smaller sizes, browse our ' +
        '<a href="' + smallerUrl + '">Lingerie Sets</a> and <a href="' + smallerUrl2 + '">Bodysuits</a> (XS\u2013XL).';
      var belowTop = topRes && (topRes.below || topRes.clamped === 'min');
      var belowBot = botRes && (botRes.below || botRes.clamped === 'min');
      if (belowTop) warn.push('Your bust is below this style\u2019s range \u2014 we\u2019ve picked its smallest size.');
      if (topRes && (topRes.above || topRes.clamped === 'max')) warn.push('Your bust is above this style\u2019s range \u2014 we\u2019ve picked its largest size.');
      if (belowBot) warn.push('Your waist or hips are below this style\u2019s range \u2014 we\u2019ve picked its smallest size.');
      if (botRes && (botRes.above || botRes.clamped === 'max')) warn.push('Your waist or hips are above this style\u2019s range \u2014 we\u2019ve picked its largest size.');
      if (belowTop || belowBot) warn.push(smallerLink);

      var html = '';

      if (!split) {
        // Une seule taille : on prend la plus contraignante des trois.
        var rows = API.ladderRows();
        var best = [topRes, botRes].filter(Boolean).sort(function (a, b) {
          return rows.indexOf(b.row) - rows.indexOf(a.row);
        })[0];
        var one = sizeLabel(best);   // conserve value/field, donc la
                                     // taille exacte dans le groupe
        html += '<div class="tf-sg-row"><span class="tf-sg-rowlabel">Your size</span>' +
                '<span class="tf-sg-rowsize">' + (one || '—') + '</span></div>';
        html += applyButton(one ? [['single', one]] : null, one ? one : null);
      } else if (topSize && botSize && topSize === botSize) {
        // Même groupe des deux côtés : une seule taille, pas deux
        // étiquettes pour un même vêtement.
        html += '<div class="tf-sg-row"><span class="tf-sg-rowlabel">Your size, top and bottom</span>' +
                '<span class="tf-sg-rowsize">' + topSize + '</span></div>';
        html += applyButton([['bra', topSize], ['bottom', botSize]], topSize);
      } else {
        html += '<div class="tf-sg-row"><span class="tf-sg-rowlabel">Top (by bust)</span>' +
                '<span class="tf-sg-rowsize">' + (topSize || '—') + '</span></div>';
        html += '<div class="tf-sg-row"><span class="tf-sg-rowlabel">Bottom (by waist &amp; hips)</span>' +
                '<span class="tf-sg-rowsize">' + (botSize || '—') + '</span></div>';
        if (topSize && botSize) {
          html += '<p class="tf-sg-note">Two sizes, one perfect fit — mix them freely.</p>';
          html += applyButton([['bra', topSize], ['bottom', botSize]], topSize + ' + ' + botSize);
        }
      }

      if (!topSize || !botSize) {
        warn = ['This style doesn\u2019t cover those measurements. Message us and we\u2019ll point you to one that does.'];
      }
      if (warn.length) {
        html += '<div class="tf-sg-warn">' + warn.join(' ') + '</div>';
      }

      resultEl.innerHTML = html;

      var btn = resultEl.querySelector('.tf-sg-apply');
      if (btn) {
        btn.addEventListener('click', function () {
          var plan = JSON.parse(btn.getAttribute('data-plan') || '[]');
          if (!plan.length) return;

          // On attend la confirmation avant de fermer : fermer d'abord
          // laissait la cliente devant un panier qui ne correspondait
          // pas à ce qu'elle venait de choisir.
          var original = btn.textContent;
          var before = API.currentVariantId();
          btn.disabled = true;
          btn.textContent = 'Applying\u2026';

          API.applySizes(plan, function (ok) {
            btn.disabled = false;
            btn.textContent = original;

            if (!ok) {
              var warn = resultEl.querySelector('.tf-sg-warn') || document.createElement('div');
              warn.className = 'tf-sg-warn';
              warn.textContent = 'We couldn\u2019t set that size automatically. ' +
                'Close this and pick ' + plan.map(function (p) { return p[1]; }).join(' + ') +
                ' on the page.';
              if (!warn.parentNode) resultEl.appendChild(warn);
              return;
            }

            if (window.TF_SG_DEBUG) {
              console.log('[TF Fit] variante', before, '->', API.currentVariantId());
            }

            closeModal();
            // Après le délai de fermeture : unlockBody() restaure la
            // position de défilement, un scroll antérieur serait annulé.
            setTimeout(function () {
              API.scrollToSelectors();
              API.flashSelectors();
            }, 300);
          });
        });
      }
    }

    function applyButton(plan, label) {
      if (!plan || !label) return '<button type="button" class="tf-sg-apply" disabled>Select</button>';
      return '<button type="button" class="tf-sg-apply" data-plan=\'' +
             JSON.stringify(plan) + '\'>Select ' + label + '</button>';
    }

    /* ─── Mémoire ───────────────────────────────────────────────── */
    function save() {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(measures)); } catch (e) {}
    }
    function load() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        var m = JSON.parse(raw);
        ['bust','waist','hips'].forEach(function (k) {
          if (typeof m[k] === 'number' && isFinite(m[k])) measures[k] = m[k];
        });
      } catch (e) {}
    }

    /* ─── Onglets & ouverture ───────────────────────────────────── */
    /* Le liseré "Scroll for more" ne s'affiche que s'il reste du
       contenu sous la ligne de flottaison. */
    function updateCue() {
      var body = document.querySelector('.tf-sg-body');
      var cue  = document.getElementById('tf-sg-cue');
      if (!body || !cue) return;
      cue.querySelector('span').textContent =
        panCalc.hidden ? 'Scroll for more' : 'Scroll to see your size';
      var more = (body.scrollHeight - body.clientHeight > 24) &&
                 (body.scrollTop < body.scrollHeight - body.clientHeight - 16);
      cue.classList.toggle('is-hidden', !more);
    }

    function showTab(which) {
      var isChart = which === 'chart';
      tabChart.setAttribute('aria-selected', isChart ? 'true' : 'false');
      tabCalc.setAttribute('aria-selected', isChart ? 'false' : 'true');
      panChart.hidden = !isChart;
      panCalc.hidden = isChart;
      setTimeout(updateCue, 30);
    }

    function renderAll() {
      renderRegions(); renderTable(); renderFields(); renderResult();
      setTimeout(updateCue, 40);
    }

    var lastFocus = null, scrollY = 0;

    /* position:fixed plutôt qu'overflow:hidden — sur iOS, overflow seul
       laisse la page défiler derrière la modale. */
    function lockBody() {
      scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      var b = document.body.style;
      b.position = 'fixed'; b.top = (-scrollY) + 'px';
      b.left = '0'; b.right = '0'; b.width = '100%';
    }
    function unlockBody() {
      var b = document.body.style;
      b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
      var d = document.documentElement, prev = d.style.scrollBehavior;
      d.style.scrollBehavior = 'auto';
      window.scrollTo(0, scrollY);
      d.style.scrollBehavior = prev;
    }

    function openModal() {
      lastFocus = document.activeElement;
      renderAll();
      overlay.setAttribute('data-open', 'true');
      lockBody();
      // Ouverture SYNCHRONE : le reflow forcé applique display:flex,
      // puis la classe déclenche le fondu. Aucune dépendance aux
      // animation frames (suspendues quand l'onglet n'est pas visible).
      void overlay.offsetHeight;
      overlay.classList.add('is-open');
      updateCue();
      closeBtn.focus();
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      setTimeout(function () {
        overlay.setAttribute('data-open', 'false');
        unlockBody();
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 240);
      /* TIFFANYA — PONT QUICKVIEW : on rend la main à la fiche produit.
         700 ms et pas 0 : le bouton « Select … » du calculateur ferme la
         modale PUIS applique la taille et fait défiler — il a besoin que
         la portée quickview tienne encore un instant. */
      if (_qvSaved) setTimeout(function () { qvRestore(false); }, 700);
    }

    /* ═══════════════════════════════════════════════════════════════
       TIFFANYA — PONT QUICKVIEW
       Ouvre CETTE modale pour un AUTRE produit que celui de la page :
       celui du quickview « View & Save ». Rien n'est dupliqué — on
       bascule le contexte (grille, système, titre, portée DOM), on rend,
       et on restaure tout à la fermeture. Le tableau affiché est donc
       celui que le moteur sort pour ce produit-là, à l'identique de sa
       fiche produit.
       ═══════════════════════════════════════════════════════════════ */
    var VALID_SYS = { UK: 1, US: 1, AU: 1, EU: 1 };
    var _qvSaved = null;

    function qvTitle() {
      var t = document.getElementById('tf-sg-title');
      if (t) t.textContent = API.productName || '';
    }

    API.openFor = function (cfg) {
      cfg = cfg || {};
      if (_qvSaved) qvRestore(true);   // ouverture enchaînée : on repart propre

      _qvSaved = {
        chart: API.chart, system: API.system, home: homeSystem,
        country: API.country, name: API.productName, sizes: API.availableSizes
      };

      if (cfg.scope && typeof API.setScope === 'function') API.setScope(cfg.scope);
      if (cfg.chart) API.chart = cfg.chart;
      if (cfg.country) API.country = cfg.country;
      if (cfg.productName) API.productName = cfg.productName;
      if (cfg.system && VALID_SYS[cfg.system]) {
        API.system = cfg.system;
        homeSystem = cfg.system;
        activeSystem = cfg.system;
        syncTab();
        calcUnit = activeTab.unit;
      }
      // Tailles réellement proposées PAR LE QUICKVIEW (portée imposée).
      if (typeof API.refreshSizes === 'function') API.refreshSizes();

      qvTitle();
      showTab('chart');
      openModal();
    };

    function qvRestore(silent) {
      var s = _qvSaved;
      _qvSaved = null;
      if (typeof API.releaseScope === 'function') API.releaseScope();
      if (!s) return;

      API.chart = s.chart;
      API.country = s.country;
      API.productName = s.name;
      API.availableSizes = s.sizes;
      if (s.system && VALID_SYS[s.system]) {
        API.system = s.system;
        homeSystem = s.home || s.system;
        activeSystem = homeSystem;
        syncTab();
        calcUnit = activeTab.unit;
      }
      qvTitle();
      // Remet les notes « Fits: » de la fiche produit dans leur état.
      if (!silent && typeof API.refreshAll === 'function') API.refreshAll();
    }

    // Écoute uniquement .tf-sg-open, jamais la classe générique
    // .tf-sc-trigger-btn que les autres modales du thème partagent.
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.tf-sg-open') : null;
      if (t) { e.preventDefault(); openModal(); }
    });
    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.getAttribute('data-open') === 'true') closeModal();
    });
    var bodyEl = document.querySelector('.tf-sg-body');
    if (bodyEl) bodyEl.addEventListener('scroll', updateCue, { passive: true });
    window.addEventListener('resize', updateCue);

    tabChart.addEventListener('click', function () { showTab('chart'); });
    tabCalc.addEventListener('click',  function () { showTab('calc'); });
    unitCm.addEventListener('click', function () { calcUnit = 'cm'; renderFields(); });
    unitIn.addEventListener('click', function () { calcUnit = 'in'; renderFields(); });

    load();
    renderAll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

})();